import React from 'react';
import { Card, CardProps, Container, ContainerProps, IconButton, Stack, StackProps, Typography } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';
interface CardPropsExtended extends CardProps {}

interface StackPropsExtended extends StackProps {}

interface CardTypes extends ContainerProps {
    children: React.ReactNode;
    cardProps?: CardPropsExtended;
    stackProps?: StackPropsExtended;
    hideButton?: boolean;
    backButtonNavigation?: () => void;
}

const CardWrapper = ({ children, cardProps, stackProps, hideButton, backButtonNavigation, ...props }: CardTypes) => {
    const navigation = useNavigate();
    const handleNavigation = () => {
        navigation(-1);
    };
    return (
        <Card sx={{ p: 4, my: 2, mx: '2vh', boxShadow: 'none' }} {...cardProps}>
            {hideButton ? null : (
                <Stack direction="row" alignItems="center">
                    <IconButton onClick={backButtonNavigation || handleNavigation}>
                        <KeyboardBackspaceIcon />
                    </IconButton>
                    <Typography>Back</Typography>
                </Stack>
            )}
            <Container sx={{ my: 1 }} {...props}>
                <Stack {...stackProps}>{children}</Stack>
            </Container>
        </Card>
    );
};

export default CardWrapper;
